/* eslint-disable import/extensions */
import axios from 'axios';
import BaseService from '_services/rest/base';
import UserService from '_services/rest/modules/user';
import Config from '_config';
import SessionService from '_services/common/sessionService';

import axiosHeader from '_common/runs/axios';
import router from '../../../router';
import store from '../../../store/modules/alert';

const isDev = !['production', 'staging'].includes(process.env.NODE_ENV);


class AuthService extends BaseService {
  static get LOGIN_RULES() {
    return {
      username: 'required',
      password: 'required',
    };
  }

  static get FORGET_PASS_RULES() {
    return {
      email: 'required|email',
    };
  }

  constructor() {
    super();
  }

  checkToken(token) {
    return this.request(`${this.getUrlPassword()}/find/${token}`)
      .then(response => response)
      .catch(error => {
        console.log('error', error);
        throw error;
      });
  }

  forgetPassword(email) {
    return this.validate({ email }, AuthService.FORGET_PASS_RULES)
      .then(() => axios.post(`${this.getUrlPassword()}/create`, { email })
        .then(response => response.data)
        .catch(err => {
          throw err;
        }))
      .catch(error => {
        throw error;
      });
  }

  getToken(params) {
    return axios.post(`${this.getUrl()}/oauth/token`, params)
      .then(result => {
        this.setLocalStorageToken(result.data);
        const token = result.data.access_token;
        axiosHeader();
        return UserService.setUserLocalStorage()
          .then(response => {
            UserService.setCookie(result.data.expires_in, response);
            return ({ token, userUpdate: response });
          });
      })
      .catch(error => {
        throw this.error(error);
      });
  }

  resetUser(error) {
    UserService.setUserLocalStorage()
      .then(() => {
        store.state.message = error.message;
        store.state.theme = 'danger';
        store.state.active = 6;
        router.push('/admin/overview');
      });
  }

  getUrl() {
    return super.getUrl();
  }

  getUrlPassword() {
    return `${this.getUrl()}/api/password`;
  }

  login(user) {
    if (isDev && !user) {
      user = {
        username: Config.TEST_USER,
        password: Config.TEST_PASS,
      };
    }

    return this.getToken({
      username: user.username,
      password: user.password,
      client_id: Config.CLIENT_ID,
      client_secret: Config.CLIENT_SECRET,
      grant_type: Config.GRANT_TYPE,
    });
  }

  logout() {
    return new Promise(resolve => {
      SessionService.removeSession('_refresh_token');
      SessionService.removeSession('_token');
      SessionService.removeSession('_user');
      SessionService.removeCookie('_id');

      axiosHeader();
      resolve();
    });
  }

  recoverPassword(user) {
    return axios
      .post(`${this.getUrlPassword()}/reset`, {
        email: user.email,
        password: user.newPassword,
        password_confirmation: user.confirmNewPassword,
        token: user.token,
      })
      .then(response => response.data)
      .catch(error => {
        throw error.response.data;
      });
  }

  refreshToken() {
    return this.getToken({
      refresh_token: SessionService.getLocalData('_refresh_token'),
      client_id: Config.CLIENT_ID,
      client_secret: Config.CLIENT_SECRET,
      grant_type: 'refresh_token',
    });
  }

  setLocalStorageToken(result) {
    // axios.defaults.headers.common.Authorization = `${tokenType} ${token}`
    SessionService.setLocalData('_token', result.access_token);
    SessionService.setLocalData('_refresh_token', result.refresh_token);
  }
}

export default new AuthService();
